var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.longitude && _vm.latitude && _vm.imgUrl)?_c('v-responsive',{staticClass:"map-image text-xs-center"},[_c('v-img',{staticClass:"hidden-md-and-up",staticStyle:{"width":"100%","max-width":"550px"},attrs:{"src":_vm.imgUrl}}),_c('v-img',{staticClass:"hidden-sm-and-down",staticStyle:{"width":"100%"},attrs:{"src":_vm.imgUrl}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }